import React from 'react';

const RightArrowWithCircle = ({ style = {} }) => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      style={style}
      className="c-RightArrowWithCircle"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 24.248C19.9768 24.248 24.4166 19.8082 24.4166 14.3313C24.4166 8.85452 19.9768 4.41467 14.5 4.41467C9.02316 4.41467 4.58331 8.85452 4.58331 14.3313C4.58331 19.8082 9.02316 24.248 14.5 24.248ZM14.5 25.998C20.9433 25.998 26.1666 20.7747 26.1666 14.3313C26.1666 7.88802 20.9433 2.66467 14.5 2.66467C8.05666 2.66467 2.83331 7.88802 2.83331 14.3313C2.83331 20.7747 8.05666 25.998 14.5 25.998Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6843 19.5106C15.3426 19.1689 15.3426 18.6148 15.6843 18.2731L18.8042 15.1532L8.08335 15.1532C7.6001 15.1532 7.20835 14.7615 7.20835 14.2782C7.20835 13.795 7.6001 13.4032 8.08335 13.4032L18.8042 13.4032L15.6843 10.2833C15.3426 9.94159 15.3426 9.38757 15.6843 9.04586C16.026 8.70415 16.5801 8.70415 16.9218 9.04586L21.5354 13.6595C21.6995 13.8236 21.7917 14.0461 21.7917 14.2782C21.7917 14.5103 21.6995 14.7328 21.5354 14.8969L16.9218 19.5106C16.5801 19.8523 16.026 19.8523 15.6843 19.5106Z"
        fill="#333333"
      />
    </svg>
  );
};

export default RightArrowWithCircle;
